import zionDebug from '@fs/zion-debug'
import { doFetchPost, getXRequestId, tempWindowFSRemoteLog } from './apiService'
import { ALL_PLACE_PERMISSIONS } from './placePermissionHelpers'

const debug = zionDebug('standards:places:apiService')

/**
 * Get authorization for multiple permissions within a context.
 * @return {Promise} CAS Authorization object.
 */
export async function getPlacePermissions() {
  const context = 'place'

  // Create AuthorizationBatchRequest format for new CAS v2 endpoint
  const authorizationBatchRequest = {
    authorizationRequests: [
      {
        context,
        permissions: ALL_PLACE_PERMISSIONS,
      },
    ],
  }

  const editAuthUrl = '/service/ident/cas/cas-public-api/authorizations'
  let resp
  try {
    resp = await doFetchPost(editAuthUrl, authorizationBatchRequest, {
      headers: {
        accept: 'application/cas-v2+json',
        'Content-Type': 'application/json',
        'X-Request-ID': getXRequestId(),
      },
    })
  } catch (err) {
    debug('Error while checking CAS permissions:', err)
    tempWindowFSRemoteLog(`Error while checking CAS permissions:${JSON.stringify(err)}`, 1)
    return { err: { status: err.response?.status || err.status || 500 } }
  }
  debug('resp checking CAS permissions:', resp)

  const authorizationResult = resp.data.results[0]
  const permissions = {}

  // Set authorized permissions to true
  authorizationResult.authorizedPermissions.forEach((perm) => {
    permissions[perm] = true
  })

  // Set unauthorized permissions to false
  authorizationResult.unauthorizedPermissions.forEach((perm) => {
    permissions[perm] = false
  })
  debug('permissions:', permissions)

  return permissions
}
